unit PrepareNetNumberType;

interface

uses
  NetNumberType, NetNumberStatusType, OperationType, UserType;

type
  TPrepareNetNumberType = class
  private
    fPrepareNetNumberKey: String;
    fNetNumber: TNetNumberType;
    fNetNumberStatus: TNetNumberStatusType;
    fOperation: TOperationType;
    fRemarks: String;
    fRemarksCSA: String;
    fRemarksOR: String;
    fWeigth: Single;
    fPrepareDate: String;
    fPrepareTime: String;
    fPreparedBy: TUserType;
  public
    property PrepareNetNumberKey: String read fPrepareNetNumberKey;
    property NetNumber: TNetNumberType read fNetNumber;
    property NetNumberStatus: TNetNumberStatusType read fNetNumberStatus;
    property Operation: TOperationType read fOperation;
    property Remarks: String read fRemarks;
    property RemarksCSA: String read fRemarksCSA;
    property RemarksOR: String read fRemarksOR;
    property Weigth: Single read fWeigth;
    property PrepareDate: String read fPrepareDate;
    property PrepareTime: String read fPrepareTime;
    property PreparedBy: TUserType read fPreparedBy;
  end;

implementation

end.
